import { useEffect } from 'react';

// Keyboard save, on EVERY page (desktop and phone browsers with a keyboard):
//   • Ctrl+S        — Save: presses the main save button of the top-most open
//                     dialog (its footer's primary button: Save / Add Guest /
//                     Add Family / Save payment …);
//   • Ctrl+Shift+S  — Save & next: presses the dialog's "… next …" button
//                     (Save & next family, Save & add next) — or Save when the
//                     dialog has none.
// With no dialog open, a page's own save button marked data-save="primary"
// (Quick add grid, Profile) is used. The browser's "Save page as" never opens.
// A button marked data-save="off" (e.g. the contact-upload consent) is never
// pressed by the shortcut. The focused field is blurred first, so values that
// commit on blur are saved too.
const usable = (b) => b && !b.disabled && b.offsetParent !== null && b.dataset.save !== 'off';

function findButton(shift) {
  const dialogs = [...document.querySelectorAll('.modal-back .modal')];
  const top = dialogs[dialogs.length - 1];
  if (top) {
    const foot = [...top.querySelectorAll('.modal-foot button, .modal-foot [type="submit"]')].filter(usable);
    if (shift) {
      const next = foot.find(b => /next/i.test(b.textContent || ''));
      if (next) return next;
    }
    const primary = foot.filter(b => b.classList.contains('primary'));
    return primary[primary.length - 1] || null;
  }
  const marked = [...document.querySelectorAll('[data-save="primary"]')].filter(usable);
  return marked[marked.length - 1] || null;
}

export default function SaveKeyHandler() {
  useEffect(() => {
    const onKey = (e) => {
      if (!(e.ctrlKey || e.metaKey) || e.altKey || String(e.key).toLowerCase() !== 's') return;
      e.preventDefault();                       // never the browser's "Save page as"
      const btn = findButton(e.shiftKey);
      if (!btn) return;
      const el = document.activeElement;
      if (el && el !== document.body && typeof el.blur === 'function') el.blur();
      setTimeout(() => btn.click(), 0);         // after blur handlers have run
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, []);
  return null;
}
